import styled, { css } from "styled-components";
import { lg, sm, xl, xxl } from "styles/breakpoint";
import { theme } from "styles/theme";

const StyledFooter = styled.footer`
  background: #222222;
  color: ${theme.text.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  .footer__layout {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1830px;
    width: 100%;
    margin: 0 auto;
  }
  .footer__title {
    padding-top: 120px;
    padding-bottom: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .footer__bottom {
    &-wrapper {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      .menu {
        padding-right: 40px;
        .title {
          font-size: 24px;
          font-weight: 700;
          margin-bottom: 10px;
        }
        .link {
          &-item {
            margin-bottom: 5px;
            a {
              text-decoration: none;
              color: ${theme.text.secondary};
              transition: color 0.2s ease-out;
              cursor: pointer;
              &:hover {
                color: white;
              }
            }
          }
        }
        .link--social {
          display: flex;
          flex-direction: row;
          .link-item {
            cursor: pointer;
            .icon {
              color: ${theme.colors.white};
              font-size: 22px;
              margin-right: 10px;
              transition: 0.25s;
              &:hover {
                color: ${theme.colors.secondary[900]};
                transition: 0.25s;
              }
            }
          }
        }
      }
    }
  }
  .footer__license {
    padding: 50px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    &-item {
      display: flex;
      justify-content: center;
      align-items: center;
      .iconplus {
        padding-left: 20px;
      }
    }
  }
  .footer__copyright {
    max-width: 892px;
    padding: 15px 0;
    color: #8c8c8c;
    text-align: center;
    p {
      line-height: 21px;
    }
  }
  ${xxl(css`
    .footer__license {
      padding: 50px 0;
    }
  `)}
  ${xl(css`
    .footer__title {
      padding: 60px 0;
      img {
        width: 180px !important;
      }
    }
    .footer__license {
      padding: 30px 0;
    }
    .footer__bottom-wrapper {
      grid-template-columns: 1fr 1fr 1fr;
    }
  `)}
  ${lg(css`
    .footer__license {
      padding: 15px 0;
    }
    .footer__bottom-wrapper {
      grid-template-columns: 1fr 1fr;
      grid-gap: 10px;
    }
  `)}
  ${sm(css`
    .footer__title {
      padding: unset;
      padding-top: 30px;
      img {
        width: 120px !important;
      }
    }
    .footer__license {
      padding: 15px 0;
    }
    .footer__bottom-wrapper {
      grid-template-columns: 1fr;
      grid-gap: 10px;
    }
  `)}
`;
export default StyledFooter;
